import ListingInformationRouter from './ListingInformation.router';

export default ListingInformationRouter;
